import { PERMISSION_CODE } from "../constants/permission";
import { MODULE_ROUTE } from "../routers/module-router";
import CookieUtils from "../utils/cookie-utils";

const DASHBOARD_PERMISSION = "DASHBOARD_VIEW";

/**
 * Route mặc định sau khi đăng nhập.
 * Ưu tiên Dashboard; nếu user không có quyền DASHBOARD_VIEW (và không phải ADMIN)
 * thì đưa về trang Profile để tránh hiển thị màn "Không có quyền truy cập".
 * Đọc trực tiếp từ cookie để dùng được cả ngoài React component.
 */
export const getDefaultLandingRoute = (): string => {
  const codes = CookieUtils.getCurrentUser().privilege_codes ?? [];
  const canViewDashboard =
    codes.includes(PERMISSION_CODE.ADMIN) || codes.includes(DASHBOARD_PERMISSION);
  return canViewDashboard ? MODULE_ROUTE.DASHBOARD : MODULE_ROUTE.PROFILE;
};

export const usePermission = () => {
  const userPermissions = CookieUtils.getCurrentUser().privilege_codes ?? [];

  const hasPermission = (requiredPermissions: string[]) => {
    if (userPermissions.includes(PERMISSION_CODE.ADMIN)) {
      return true;
    }
    // Allow access if permissions includes "*" wildcard
    if (requiredPermissions.length === 0) {
      return true;
    }
    return requiredPermissions.some((permission) =>
      userPermissions.includes(permission)
    );
  };

  return { hasPermission };
};
